module.exports = __webpack_public_path__ + "img/24.f10baf30.png";